import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TEMPLATES_URL } from './helpers';
import { IDocumentAssemblerTemplateResponse } from './types';

export const useDocumentAssemblerTemplate = (templateId: string | null) => {
  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerTemplateResponse>(
      templateId ? `${TEMPLATES_URL}/${templateId}` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { template: data?.template, error, isLoading, mutate };
};
